import React, { useState } from 'react';
import './Management.css';
import HomePlanForm from './HomePlan';

const navItems = [
  { label: 'Home Plans and Elevations', icon: '🏡' },

];

const tabContentMap = {
  'Home Plans and Elevations': (
    <>
      <h3>Manage Your Home Plans and Elevation here</h3>
      <HomePlanForm />
    </>
  ),
};

function ManagementDashboard() {
  const [activeTab, setActiveTab] = useState('Home Plans and Elevations');

  return (
    // A root container for better overall styling control
    <div className="management-container">
      <header className="management-header">
        <div className="header-title">Management Portal</div>
        <nav className="management-nav">
          {navItems.map((item) => (
            <button
              type="button"
              className={`nav-link${activeTab === item.label ? ' active' : ''}`}
              key={item.label}
              onClick={() => setActiveTab(item.label)}
            >
              <span>{item.icon}</span> {item.label}
            </button>
          ))}
        </nav>
      </header>

      <main className="management-main">
        {tabContentMap[activeTab]}
      </main>
    </div>
  );
}

export default ManagementDashboard;